export default __webpack_public_path__ + "static/media/home_bg.2b281dd2.png";